import { useEffect } from 'react';
import { useRouter } from 'next/router';
import NextNProgress from 'nextjs-progressbar';

import { useAppDispatch } from 'store';

import { openAuthModal, setAuthenticated, setRedirectUrl, setRequiredModal } from 'modules/auth';
import { globalConst, setLoading, setUser, useLoginWithTelegram, useUserData } from 'modules/global';

import { AuthModal } from './auth';
import FeedbackModal from './feedback-modal';
import Footer from './footer';
import Header from './header';
import RouteLoader from './router-loading';

export const MainLayout = ({ children }: { children: React.ReactNode }) => {
  const { route, query, pathname, asPath } = useRouter();
  const dispatch = useAppDispatch();
  const { user, isLoading, isFetching } = useUserData();
  const { mutate } = useLoginWithTelegram();

  const shouldShowFooter = !globalConst.hiddenFooterRoutes.includes(route);
  const shouldHideHeader = !globalConst.hiddenHeaderRoutes.includes(route);

  const checkAuth = [
    `${globalConst.pageNames.ONLINE_OLYMPIC}/[olympicId]`,
    `${globalConst.pageNames.COURSES}/[course]/[lesson]`
  ];

  useEffect(() => {
    if (query?.hashcode && typeof query?.hashcode === 'string') {
      mutate({ hashCode: query?.hashcode, pathname });
    } else {
      dispatch(setAuthenticated({ status: true }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query?.hashcode]);

  useEffect(() => {
    const isUserLoading = isLoading || isFetching;

    dispatch(setLoading(isUserLoading));

    if (isUserLoading) return;

    const isAuth = !!user?.phone;

    if (user) {
      dispatch(setUser(user));
    }
    if (!isAuth && checkAuth.includes(route)) {
      dispatch(setRedirectUrl(asPath));
      dispatch(openAuthModal());
      dispatch(setRequiredModal());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, isLoading, isFetching]);

  return (
    <>
      {shouldHideHeader && <Header />}
      <RouteLoader />
      <NextNProgress options={{ showSpinner: false }} color={globalConst.colors.primary} />
      {children}
      {shouldShowFooter && <Footer />}
      <FeedbackModal />
      <AuthModal />
    </>
  );
};
